/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ClearingHouse } from '../models';
// @ts-ignore
import type { ClearingHouseListResponseModel } from '../models';
// @ts-ignore
import type { ClearingHousePatchModel } from '../models';
// @ts-ignore
import type { ClearingHouseResponseModel } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * ClearingHouseApi - axios parameter creator
 * @export
 */
export const ClearingHouseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all clearing houses
         * @summary Get all clearing houses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClearingHouse: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clearingHouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a clearing house by ID
         * @summary Get clearing house by ID
         * @param {string} clearingHouseProfileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClearingHouseById: async (clearingHouseProfileId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clearingHouseProfileId' is not null or undefined
            assertParamExists('getClearingHouseById', 'clearingHouseProfileId', clearingHouseProfileId)
            const localVarPath = `/api/v1/clearingHouse/{clearingHouseProfileId}`
                .replace(`{${"clearingHouseProfileId"}}`, encodeURIComponent(String(clearingHouseProfileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Patch a clearing house
         * @summary Patch clearing house
         * @param {ClearingHousePatchModel} clearingHousePatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchClearingHouse: async (clearingHousePatchModel: ClearingHousePatchModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clearingHousePatchModel' is not null or undefined
            assertParamExists('patchClearingHouse', 'clearingHousePatchModel', clearingHousePatchModel)
            const localVarPath = `/api/v1/clearingHouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clearingHousePatchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a new clearing house
         * @summary Create clearing house
         * @param {ClearingHouse} clearingHouse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClearingHouse: async (clearingHouse: ClearingHouse, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clearingHouse' is not null or undefined
            assertParamExists('postClearingHouse', 'clearingHouse', clearingHouse)
            const localVarPath = `/api/v1/clearingHouse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clearingHouse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClearingHouseApi - functional programming interface
 * @export
 */
export const ClearingHouseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClearingHouseApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all clearing houses
         * @summary Get all clearing houses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClearingHouse(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClearingHouseListResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClearingHouse(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClearingHouseApi.getClearingHouse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a clearing house by ID
         * @summary Get clearing house by ID
         * @param {string} clearingHouseProfileId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClearingHouseById(clearingHouseProfileId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClearingHouseResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClearingHouseById(clearingHouseProfileId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClearingHouseApi.getClearingHouseById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Patch a clearing house
         * @summary Patch clearing house
         * @param {ClearingHousePatchModel} clearingHousePatchModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchClearingHouse(clearingHousePatchModel: ClearingHousePatchModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchClearingHouse(clearingHousePatchModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClearingHouseApi.patchClearingHouse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a new clearing house
         * @summary Create clearing house
         * @param {ClearingHouse} clearingHouse 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postClearingHouse(clearingHouse: ClearingHouse, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postClearingHouse(clearingHouse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClearingHouseApi.postClearingHouse']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClearingHouseApi - factory interface
 * @export
 */
export const ClearingHouseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClearingHouseApiFp(configuration)
    return {
        /**
         * Get all clearing houses
         * @summary Get all clearing houses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClearingHouse(options?: RawAxiosRequestConfig): AxiosPromise<Array<ClearingHouseListResponseModel>> {
            return localVarFp.getClearingHouse(options).then((request) => request(axios, basePath));
        },
        /**
         * Get a clearing house by ID
         * @summary Get clearing house by ID
         * @param {ClearingHouseApiGetClearingHouseByIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClearingHouseById(requestParameters: ClearingHouseApiGetClearingHouseByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClearingHouseResponseModel> {
            return localVarFp.getClearingHouseById(requestParameters.clearingHouseProfileId, options).then((request) => request(axios, basePath));
        },
        /**
         * Patch a clearing house
         * @summary Patch clearing house
         * @param {ClearingHouseApiPatchClearingHouseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchClearingHouse(requestParameters: ClearingHouseApiPatchClearingHouseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchClearingHouse(requestParameters.clearingHousePatchModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a new clearing house
         * @summary Create clearing house
         * @param {ClearingHouseApiPostClearingHouseRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postClearingHouse(requestParameters: ClearingHouseApiPostClearingHouseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.postClearingHouse(requestParameters.clearingHouse, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClearingHouseApi - interface
 * @export
 * @interface ClearingHouseApi
 */
export interface ClearingHouseApiInterface {
    /**
     * Get all clearing houses
     * @summary Get all clearing houses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApiInterface
     */
    getClearingHouse(options?: RawAxiosRequestConfig): AxiosPromise<Array<ClearingHouseListResponseModel>>;

    /**
     * Get a clearing house by ID
     * @summary Get clearing house by ID
     * @param {ClearingHouseApiGetClearingHouseByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApiInterface
     */
    getClearingHouseById(requestParameters: ClearingHouseApiGetClearingHouseByIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClearingHouseResponseModel>;

    /**
     * Patch a clearing house
     * @summary Patch clearing house
     * @param {ClearingHouseApiPatchClearingHouseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApiInterface
     */
    patchClearingHouse(requestParameters: ClearingHouseApiPatchClearingHouseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Create a new clearing house
     * @summary Create clearing house
     * @param {ClearingHouseApiPostClearingHouseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApiInterface
     */
    postClearingHouse(requestParameters: ClearingHouseApiPostClearingHouseRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for getClearingHouseById operation in ClearingHouseApi.
 * @export
 * @interface ClearingHouseApiGetClearingHouseByIdRequest
 */
export interface ClearingHouseApiGetClearingHouseByIdRequest {
    /**
     * 
     * @type {string}
     * @memberof ClearingHouseApiGetClearingHouseById
     */
    readonly clearingHouseProfileId: string
}

/**
 * Request parameters for patchClearingHouse operation in ClearingHouseApi.
 * @export
 * @interface ClearingHouseApiPatchClearingHouseRequest
 */
export interface ClearingHouseApiPatchClearingHouseRequest {
    /**
     * 
     * @type {ClearingHousePatchModel}
     * @memberof ClearingHouseApiPatchClearingHouse
     */
    readonly clearingHousePatchModel: ClearingHousePatchModel
}

/**
 * Request parameters for postClearingHouse operation in ClearingHouseApi.
 * @export
 * @interface ClearingHouseApiPostClearingHouseRequest
 */
export interface ClearingHouseApiPostClearingHouseRequest {
    /**
     * 
     * @type {ClearingHouse}
     * @memberof ClearingHouseApiPostClearingHouse
     */
    readonly clearingHouse: ClearingHouse
}

/**
 * ClearingHouseApi - object-oriented interface
 * @export
 * @class ClearingHouseApi
 * @extends {BaseAPI}
 */
export class ClearingHouseApi extends BaseAPI implements ClearingHouseApiInterface {
    /**
     * Get all clearing houses
     * @summary Get all clearing houses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApi
     */
    public getClearingHouse(options?: RawAxiosRequestConfig) {
        return ClearingHouseApiFp(this.configuration).getClearingHouse(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a clearing house by ID
     * @summary Get clearing house by ID
     * @param {ClearingHouseApiGetClearingHouseByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApi
     */
    public getClearingHouseById(requestParameters: ClearingHouseApiGetClearingHouseByIdRequest, options?: RawAxiosRequestConfig) {
        return ClearingHouseApiFp(this.configuration).getClearingHouseById(requestParameters.clearingHouseProfileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Patch a clearing house
     * @summary Patch clearing house
     * @param {ClearingHouseApiPatchClearingHouseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApi
     */
    public patchClearingHouse(requestParameters: ClearingHouseApiPatchClearingHouseRequest, options?: RawAxiosRequestConfig) {
        return ClearingHouseApiFp(this.configuration).patchClearingHouse(requestParameters.clearingHousePatchModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a new clearing house
     * @summary Create clearing house
     * @param {ClearingHouseApiPostClearingHouseRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClearingHouseApi
     */
    public postClearingHouse(requestParameters: ClearingHouseApiPostClearingHouseRequest, options?: RawAxiosRequestConfig) {
        return ClearingHouseApiFp(this.configuration).postClearingHouse(requestParameters.clearingHouse, options).then((request) => request(this.axios, this.basePath));
    }
}

